/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SalesTabData } from "./SalesTabData";
import {
  SalesTabDataFromJSON,
  SalesTabDataFromJSONTyped,
  SalesTabDataToJSON,
  SalesTabDataToJSONTyped,
} from "./SalesTabData";

/**
 *
 * @export
 * @interface SalesDashboard
 */
export interface SalesDashboard {
  /**
   *
   * @type {Array<SalesTabData>}
   * @memberof SalesDashboard
   */
  dataByMonth: Array<SalesTabData>;
  /**
   *
   * @type {number}
   * @memberof SalesDashboard
   */
  insuranceCount: number;
  /**
   *
   * @type {number}
   * @memberof SalesDashboard
   */
  avgInsuranceAmount?: number | null;
  /**
   *
   * @type {number}
   * @memberof SalesDashboard
   */
  claimsRatio: number;
  /**
   *
   * @type {number}
   * @memberof SalesDashboard
   */
  additionalChargeRatio: number;
  /**
   *
   * @type {number}
   * @memberof SalesDashboard
   */
  perfectShipmentCount: number;
  /**
   *
   * @type {number}
   * @memberof SalesDashboard
   */
  trackedShipmentCount: number;
}

/**
 * Check if a given object implements the SalesDashboard interface.
 */
export function instanceOfSalesDashboard(
  value: object,
): value is SalesDashboard {
  if (!("dataByMonth" in value) || value["dataByMonth"] === undefined)
    return false;
  if (!("insuranceCount" in value) || value["insuranceCount"] === undefined)
    return false;
  if (!("claimsRatio" in value) || value["claimsRatio"] === undefined)
    return false;
  if (
    !("additionalChargeRatio" in value) ||
    value["additionalChargeRatio"] === undefined
  )
    return false;
  if (
    !("perfectShipmentCount" in value) ||
    value["perfectShipmentCount"] === undefined
  )
    return false;
  if (
    !("trackedShipmentCount" in value) ||
    value["trackedShipmentCount"] === undefined
  )
    return false;
  return true;
}

export function SalesDashboardFromJSON(json: any): SalesDashboard {
  return SalesDashboardFromJSONTyped(json, false);
}

export function SalesDashboardFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesDashboard {
  if (json == null) {
    return json;
  }
  return {
    dataByMonth: (json["dataByMonth"] as Array<any>).map(SalesTabDataFromJSON),
    insuranceCount: json["insuranceCount"],
    avgInsuranceAmount:
      json["avgInsuranceAmount"] == null
        ? undefined
        : json["avgInsuranceAmount"],
    claimsRatio: json["claimsRatio"],
    additionalChargeRatio: json["additionalChargeRatio"],
    perfectShipmentCount: json["perfectShipmentCount"],
    trackedShipmentCount: json["trackedShipmentCount"],
  };
}

export function SalesDashboardToJSON(json: any): SalesDashboard {
  return SalesDashboardToJSONTyped(json, false);
}

export function SalesDashboardToJSONTyped(
  value?: SalesDashboard | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    dataByMonth: (value["dataByMonth"] as Array<any>).map(SalesTabDataToJSON),
    insuranceCount: value["insuranceCount"],
    avgInsuranceAmount: value["avgInsuranceAmount"],
    claimsRatio: value["claimsRatio"],
    additionalChargeRatio: value["additionalChargeRatio"],
    perfectShipmentCount: value["perfectShipmentCount"],
    trackedShipmentCount: value["trackedShipmentCount"],
  };
}
